<template>
  <section>
    <w-modal :value="value" :width="modalWidth" content-padding="px-6" @close="close">
      <template #header>
        <h1 class="font-medium text-xl">
          例行性訂購設定
        </h1>
      </template>
      <template #content>
        <div>
          <div class="schedule flex items-center h-14 mt-2">
            <b-field horizontal label="啟用自動開團">
              <b-switch
                v-model="v$.enableSchedule.$model"
                class="ml-2 mr-6"
                size="is-small"
              />
            </b-field>
            <w-button
              v-if="enableSchedule"
              size="func"
              type="outlined"
              @click="openSettingsModal"
            >
              {{ hasSchedule ? '編輯設定' : '前往設定' }}
            </w-button>
          </div>
          <schedule-list
            v-if="hasSchedule"
            :schedule="schedule"
            :schedules="schedules"
          />
        </div>
      </template>
      <template #footer>
        <div class="flex items-center justify-end">
          <w-button
            :disabled="isConfirmBtnDisable"
            :loading="isLoading"
            @click="onConfirm"
          >
            確定
          </w-button>
        </div>
      </template>
    </w-modal>
    <schedule-modal
      v-model="openScheduleModal"
      :department-ids="departmentIds"
      :receive-date-start="receiveDateStart"
      :schedule="schedule"
      @close="openScheduleModal = false"
      @confirm="onScheduleChange"
    />
    <schedule-confirm-modal
      v-model="openScheduleChangeConfirmModal"
      :loading="isLoading"
      title="確定變更設定？"
      @close="onScheduleChangeConfirmModalClose"
      @confirm="onScheduleChangeConfirm"
    />
    <schedule-confirm-modal
      v-model="openScheduleCloseConfirmModal"
      :loading="isLoading"
      title="確定關閉自動開團？"
      @close="openScheduleCloseConfirmModal = false"
      @confirm="onScheduleCloseConfirm"
    />
  </section>
</template>

<script>
import ScheduleListModal from './ScheduleListModal';

export default ScheduleListModal;
</script>

<style lang="scss" scoped>
@import './ScheduleListModal';
</style>
